const BASE_URL = process.env.REACT_APP_BASE_URL;
const BASE_URL_V2 = `${BASE_URL}/v2`;
export const LOGIN_URL = `${BASE_URL}/auth/login`;
export const LOGIN_AS_URL = `${BASE_URL}/auth/login-as`;
export const LOGOUT_URL = `${BASE_URL}/auth/logout`;
export const VERIFY_CODE_URL = `${BASE_URL}/auth/verify-code`;
export const RE_SEND_CODE_URL = `${BASE_URL}/auth/resend-code`;
export const GET_CUSTOMER_URL = `${BASE_URL}/customer`;
export const GENERATE_PASSWORD = `${BASE_URL}/auth/generate-password`;
export const FORGOT_PASSWORD = `${BASE_URL}/auth/remind-password`;
export const RESET_PASSWORD = `${BASE_URL}/auth/reset-password`;
export const CHANGE_PASSWORD = `${BASE_URL}/auth/change-password`;
export const SETTINGS = `${BASE_URL}/settings`;
export const COUNTRY_URL = `${BASE_URL}/country`;
export const USER_URL = `${BASE_URL}/user`;
export const LANGUAGE_URL = `${BASE_URL}/languages`;
export const MODULE_URL = `${BASE_URL}/module`;
export const PROFILE_URL = `${BASE_URL}/profile`;
export const SUPPLIER_URL = `${BASE_URL}/supplier`;
export const CATEGORY_URL = `${BASE_URL}/category`;
export const PRODUCT_BARCODE_URL = `${BASE_URL}/product-barcode`;
export const PRODUCT_BARCODE_FILE_URL = `${BASE_URL}/product-barcode-file`;
export const DOCUMENT_TYPE_URL = `${BASE_URL}/document-type`;
export const CURRENT_TYPE_URL = `${BASE_URL}/current-type`;
export const CURRENT_ACCOUNT_OPENING_DEMAND_URL = `${BASE_URL}/current-account-opening-demand`;
export const CURRENT_ACCOUNT_DOCUMENT_URL = `${BASE_URL}/current-account-document`;
export const CURRENT_ACCOUNT_OPENING_ATTACHMENT_URL = `${BASE_URL}/current-account-opening-attachment-file`;
export const KKDIK_DASHBOARD_URL = `${BASE_URL}/kkdik/dashboard`;
export const KKDIK_PRODUCT_URL = `${BASE_URL}/kkdik/products`;
export const KKDIK_CHEMICAL_SUBSTANCE_URL = `${BASE_URL}/kkdik/chemical-substances`;
export const KKDIK_CHEMICAL_CONTENT_URL = `${BASE_URL}/kkdik/chemical-contents`;
export const ECOM_URL = `${BASE_URL}/ecom`;
export const ROLE_URL = `${BASE_URL}/role`;
export const PERMISSION_URL = `${BASE_URL}/permission`;
export const GROUP_URL = `${BASE_URL}/group`;
export const CONTRACT_MANAGEMENT_URL = `${BASE_URL}/contract-management`;
export const CONTRACT_URL = `${BASE_URL}/cmm/contracts`;
export const CONTRACT_SCANNED_FILES_URL = `${CONTRACT_URL}/scanned`;
export const CONTRACT_ATTACHMENTS_URL = `${CONTRACT_URL}/attachments`;
export const CONTRACT_INVALID_INFORMATION_URL = `status/invalid-information`;
export const CONTRACT_AUTHORIZED_SUPPLIER_URL = `supplier-emails`;
export const PROMOTION_URL = `${BASE_URL_V2}/promotions`;
export const SUPPLIER_PROMOTIONS_URL = `${BASE_URL_V2}/supplier-promotions`;
export const PROMOTION_SUPPLIERS_URL = `${BASE_URL_V2}/suppliers`;
